import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const CreateOperator = async (operatorData, userID) => {
    try {
      const data = JSON.stringify({
        svc: "operator",
        pid: "CreateSubUser",
        dat: {
          ...operatorData,
          userID: userID,
        },
      });

      console.log(data);
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const CheckIfEmailExists = async (operatorData) => {
    try {
      const data = JSON.stringify({
        svc: "operator",
        pid: "CheckEmailExists",
        dat: {
          ...operatorData
        },
      });

      console.log(data);
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const ListOperators = async (userID) => {
    try {
      const data = JSON.stringify({
        svc: "operator",
        pid: "Listsubusers",
        dat: {
          userID: userID,
        },
      });

    //   console.log(data);
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const GetOperatorsWithID = async (
    subacctid
  ) => {
    try {
      const data = JSON.stringify({
        svc: "operator",
        pid: "GetCustomerWithID",
        dat: {
          subacctid: subacctid,
        },
      });

    //   console.log(data);
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const EditOperator = async (
    operatorData,
    userid,
    agentID
  ) => {
    try {
      const data = JSON.stringify({
        svc: "operator",
        pid: "ChangeSubUserStatus",
        dat: {
          ...operatorData,
          userid: userid,
          agentID: agentID,
        },
      });

    //   console.log(data);
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };